export default class User {
  constructor(name, password, roleId) {
    this.name = name;
    this.password = password;
    this.roleId = roleId
  }
}